// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiRepContributor } from '../models/ApiRepContributor';
import { HttpFile } from '../http/http';

export class ApiRepCategory {
    'category': string;
    'total_rep': number;
    'contributor_count': number;
    'authenticated_user_contribution': number | null;
    'top_contributors': Array<ApiRepContributor>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "category",
            "baseName": "category",
            "type": "string",
            "format": ""
        },
        {
            "name": "total_rep",
            "baseName": "total_rep",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "contributor_count",
            "baseName": "contributor_count",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "authenticated_user_contribution",
            "baseName": "authenticated_user_contribution",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "top_contributors",
            "baseName": "top_contributors",
            "type": "Array<ApiRepContributor>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiRepCategory.attributeTypeMap;
    }

    public constructor() {
    }
}

